import React from "react";
import { Link } from "react-router-dom";
import { PageShell, PageHero, PageSection } from "../components/PageShell";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import AdminNav from "../components/AdminNav";

const items = [
  { to: "/admin/users", title: "Users", desc: "Add/edit/remove users and roles." },
  { to: "/admin/devices", title: "Devices", desc: "Filter by user and manage device ownership/settings." },
  { to: "/admin/faqs", title: "FAQs", desc: "Add, edit, and remove FAQs." },
  { to: "/admin/stories", title: "Stories", desc: "Add, edit, and remove stories." },
  { to: "/admin/home-modules", title: "Home modules", desc: "Edit public home feature modules." },
  { to: "/admin/pricing-plans", title: "Pricing", desc: "Edit public pricing plans." },
  { to: "/admin/future", title: "Roadmap", desc: "Edit future updates + near-term focus." },
  { to: "/admin/rules", title: "Rules", desc: "Manage alert rule templates for users." },
  { to: "/admin/contact", title: "Contact", desc: "Edit contact content + view contact responses." },
  { to: "/admin/notifications", title: "Notifications", desc: "Send offers and app push messages to users." },
];

export default function AdminDashboard() {
  return (
    <PageShell>
      <PageHero eyebrow="Admin" title="Admin" highlight="dashboard." description="Manage users, devices and business content." />
      <PageSection variant="content">
        <div className="mx-auto max-w-7xl grid gap-6">
          <AdminNav />
          <div className="grid md:grid-cols-2 gap-6">
            {items.map((s) => (
              <Link key={s.to} to={s.to}>
                <Card className="shadow-soft">
                  <CardHeader><CardTitle>{s.title}</CardTitle></CardHeader>
                  <CardContent className="text-sm text-muted-foreground">{s.desc}</CardContent>
                </Card>
              </Link>
            ))}
          </div>
        </div>
      </PageSection>
    </PageShell>
  );
}

